import { Injectable, inject } from '@angular/core';
import { SessionService } from '../session.service';
import { formatInTimeZone } from 'date-fns-tz';

@Injectable({ providedIn: 'root' })
export class TimezoneService {
  private session = inject(SessionService);
  
  getEstablishmentTimezone(): string {
    const establishments = this.session.establishments();
    const selectedId = this.session.selectedId();
    const establishment = establishments.find(e => e.id === selectedId);
    return (establishment as any)?.tz || 'Europe/Paris';
  }

  getDateInEstablishmentTimezone(): Date {
    const tz = this.getEstablishmentTimezone();
    const now = new Date();
    
    const year = parseInt(formatInTimeZone(now, tz, 'yyyy'));
    const month = parseInt(formatInTimeZone(now, tz, 'MM')) - 1;
    const day = parseInt(formatInTimeZone(now, tz, 'dd'));
    const hour = parseInt(formatInTimeZone(now, tz, 'HH'));
    const minute = parseInt(formatInTimeZone(now, tz, 'mm'));
    const second = parseInt(formatInTimeZone(now, tz, 'ss'));
    
    return new Date(year, month, day, hour, minute, second);
  }

  formatDateForAPI(date: Date): string {
    const tz = this.getEstablishmentTimezone();
    return formatInTimeZone(date, tz, 'yyyy-MM-dd');
  }

  private getOffsetLabel(tz: string, date: Date): string {
    const parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, timeZoneName: 'shortOffset' }).formatToParts(date);
    return parts.find(p => p.type === 'timeZoneName')?.value || '';
  }

  /**
   * Suffixe court à ajouter à une heure affichée pour lever l'ambiguïté du fuseau (ex. " (Casablanca)"),
   * uniquement quand le fuseau de l'établissement diffère réellement (en offset, à cette date précise -
   * gère les DST/Ramadan) du fuseau par défaut Europe/Paris. Retourne '' sinon pour ne pas surcharger le
   * cas majoritaire (établissements en France).
   */
  getTimezoneHint(date: Date): string {
    const tz = this.getEstablishmentTimezone();
    if (this.getOffsetLabel(tz, date) === this.getOffsetLabel('Europe/Paris', date)) {
      return '';
    }
    const city = tz.split('/').pop() || tz;
    return ` (${city.replace(/_/g, ' ')})`;
  }
}